module.exports = __webpack_public_path__ + "img/6cb696c.jpg";